import { UnlimThreeStatus } from 'constants/accumulators';
import {
  AccumServiceType,
  EnrichedAccumItemType,
  UnlimitedAccumulatorVariant,
} from 'types/accumulators';
import { elkPlanBUnlimAccum3HoursEnabled } from 'utils';

export const getUnlimitedVariant = ({
  accumulator,
  services,
  tetheringIsLow,
}: {
  accumulator: EnrichedAccumItemType;
  services?: AccumServiceType;
  tetheringIsLow?: boolean;
}): UnlimitedAccumulatorVariant => {
  const isElkUnlimAccum3HoursEnabled = elkPlanBUnlimAccum3HoursEnabled();
  if (accumulator.unit === 'KBYTE' && services?.unlimited24) {
    return 'Unlimited24Hours';
  }

  if (accumulator.unit === 'KBYTE' && services?.unlimited3 && isElkUnlimAccum3HoursEnabled) {
    if (services.unlimited3?.status === UnlimThreeStatus.AVAILABLE) {
      return 'Unlimited3HoursAvailable';
    }
    if (services.unlimited3?.status === UnlimThreeStatus.COOLING) {
      return 'Unlimited3HoursCooling';
    }
    if (
      services.unlimited3?.status === UnlimThreeStatus.ACTIVE &&
      !!services.unlimited3?.expirationDate
    ) {
      return 'Unlimited3HoursActive';
    }
  }

  if (accumulator.unit === 'KBYTE' && services?.tethering) {
    return 'UnlimitedWithUnlimitedTethering';
  }

  if (
    accumulator.unit === 'KBYTE' &&
    typeof accumulator?.tetheringRest === 'number' &&
    typeof accumulator?.tetheringSize === 'number'
  ) {
    return 'UnlimitedWithLimitedTethering';
  }

  if (accumulator.unit === 'KBYTE' && accumulator.isUnlimited && tetheringIsLow === true) {
    return 'UnlimitedWithUnlimitedTethering';
  }

  return 'UnlimitedBase';
};
